export const isTileOverlay = ({ tiles }) => Number(tiles) === 1;

export const isDefaultVisibleOverlay = ({ level, category, is_360, tiles }) =>
  isTileOverlay({ tiles }) &&
  Number(level) === 0 &&
  Number(category) === 0 &&
  Number(is_360) === 1;
